"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseHTML = exports.processParams = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
/**
 * Return the object key/values into a list of key=value delimited by &
 * @param parameters
 * @returns {string}
 */
function processParams(parameters) {
    const parameterList = Object.keys(parameters)
        .map(key => {
        return `${key}=${encodeURIComponent(parameters[key])}`;
    })
        .join('&');
    return parameterList;
}
exports.processParams = processParams;
function parseHTML(htmlString) {
    const html = window_or_global_1.default.document.createElement('div');
    html.innerHTML = htmlString;
    return html;
}
exports.parseHTML = parseHTML;
//# sourceMappingURL=url.js.map